import './_media-hero.scss';

export default () => {};
